(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["30lb-landing-retail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ─── VIDEO SLIDER CONTROLS ───
    (function () {
      const carousel = document.getElementById('videoCarousel');
      if (!carousel) return;

      const videoCards = carousel.querySelectorAll('.video-card');
      if (!videoCards.length) return;

      let currentlyPlaying = null;

      function pauseAndReset(videoEl) {
        if (!videoEl) return;
        try {
          videoEl.pause();
          videoEl.currentTime = 0;
        } catch (_) {}
        const card = videoEl.closest('.video-card');
        if (card) card.classList.remove('playing');
      }

      function playVideo(videoEl) {
        if (!videoEl) return;
        if (currentlyPlaying && currentlyPlaying !== videoEl) {
          pauseAndReset(currentlyPlaying);
        }
        try {
          const promise = videoEl.play();
          if (promise !== undefined) {
            promise.catch(function (err) {});
          }
        } catch (_) {}
        const card = videoEl.closest('.video-card');
        if (card) card.classList.add('playing');
        currentlyPlaying = videoEl;
      }

      videoCards.forEach(function (card, idx) {
        const playBtn = card.querySelector('.play-btn');
        if (playBtn) {
          const playSvg = playBtn.querySelector('svg');
          if (playSvg) playSvg.classList.add('icon-play');

          const pauseSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          pauseSvg.setAttribute('viewBox', '0 0 80 80');
          pauseSvg.setAttribute('width', '60');
          pauseSvg.setAttribute('height', '60');
          pauseSvg.classList.add('icon-pause');
          pauseSvg.innerHTML =
            '<circle cx="40" cy="40" r="36" fill="rgba(255,255,255,0.9)" />' +
            '<rect x="27" y="24" width="9" height="32" rx="2" fill="#eb8aac" />' +
            '<rect x="44" y="24" width="9" height="32" rx="2" fill="#eb8aac" />';
          playBtn.appendChild(pauseSvg);
        }

        const expandBtn = document.createElement('button');
        expandBtn.className = 'expand-btn';
        expandBtn.type = 'button';
        expandBtn.setAttribute('aria-label', 'Expand video');
        expandBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/>' +
          '<path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';
        card.appendChild(expandBtn);
        expandBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openModal(idx);
        });
      });

      let modalOverlay = null;
      let modalVideoContainer = null;
      let originalParent = null;
      let originalNextSibling = null;

      function ensureModal() {
        if (modalOverlay) return;
        modalOverlay = document.createElement('div');
        modalOverlay.className = 'video-modal-overlay';

        const content = document.createElement('div');
        content.className = 'video-modal-content';

        const closeBtn = document.createElement('button');
        closeBtn.className = 'video-modal-close';
        closeBtn.type = 'button';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = '&times;';
        content.appendChild(closeBtn);

        modalVideoContainer = document.createElement('div');
        modalVideoContainer.className = 'video-modal-video-wrap';
        content.appendChild(modalVideoContainer);

        modalOverlay.appendChild(content);
        document.body.appendChild(modalOverlay);

        closeBtn.addEventListener('click', closeModal);
        modalOverlay.addEventListener('click', function (e) {
          if (e.target === modalOverlay) closeModal();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && modalOverlay.classList.contains('open')) closeModal();
        });
      }

      function openModal(idx) {
        ensureModal();
        const card = videoCards[idx];
        if (!card) return;
        const video = card.querySelector('video');
        if (!video) return;

        if (currentlyPlaying && currentlyPlaying !== video) {
          pauseAndReset(currentlyPlaying);
          currentlyPlaying = null;
        }

        originalParent = video.parentNode;
        originalNextSibling = video.nextSibling;

        video.removeAttribute('loop');
        video.setAttribute('controls', '');
        modalVideoContainer.appendChild(video);
        modalOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';

        playVideo(video);
      }

      function closeModal() {
        if (!modalOverlay) return;
        modalOverlay.classList.remove('open');
        document.body.style.overflow = '';

        const video = modalVideoContainer.querySelector('video');
        if (video) {
          pauseAndReset(video);
          video.removeAttribute('controls');
          video.setAttribute('loop', '');
          if (originalNextSibling) {
            originalParent.insertBefore(video, originalNextSibling);
          } else {
            originalParent.appendChild(video);
          }
          if (currentlyPlaying === video) currentlyPlaying = null;
        }
        originalParent = null;
        originalNextSibling = null;
      }

      const playBtns = carousel.querySelectorAll('.play-btn');
      playBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          const card = this.closest('.video-card');
          if (!card) return;
          const video = card.querySelector('video');
          if (!video) return;

          if (currentlyPlaying === video) {
            pauseAndReset(video);
            currentlyPlaying = null;
            return;
          }

          playVideo(video);
        });
      });

      videoCards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('.play-btn') || e.target.closest('.expand-btn')) return;
          const video = this.querySelector('video');
          if (!video) return;

          if (currentlyPlaying === video) {
            pauseAndReset(video);
            currentlyPlaying = null;
          } else {
            playVideo(video);
          }
        });
      });

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const card = entry.target;
            const video = card.querySelector('video');
            if (!video) return;

            if (!entry.isIntersecting) {
              if (currentlyPlaying === video) {
                pauseAndReset(video);
                currentlyPlaying = null;
              } else {
                pauseAndReset(video);
              }
            }
          });
        },
        {
          root: carousel,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      videoCards.forEach(function (card) {
        observer.observe(card);
      });

      let scrollTimeout = null;
      carousel.addEventListener(
        'scroll',
        function () {
          if (scrollTimeout) clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(function () {
            if (currentlyPlaying) {
              const card = currentlyPlaying.closest('.video-card');
              if (card) {
                const rect = card.getBoundingClientRect();
                const containerRect = carousel.getBoundingClientRect();
                const isVisible = rect.right > containerRect.left + 20 && rect.left < containerRect.right - 20;
                if (!isVisible) {
                  pauseAndReset(currentlyPlaying);
                  currentlyPlaying = null;
                }
              }
            }
          }, 80);
        },
        { passive: true }
      );

      carousel.querySelectorAll('video').forEach(function (video) {
        video.addEventListener('ended', function () {
          const card = this.closest('.video-card');
          if (card && card.classList.contains('playing')) {
            if (!this.hasAttribute('loop')) {
              pauseAndReset(this);
              if (currentlyPlaying === this) currentlyPlaying = null;
            }
          }
        });

        video.addEventListener('pause', function () {
          const card = this.closest('.video-card');
          if (card && card.classList.contains('playing')) {
            if (!this.ended) {
              card.classList.remove('playing');
              if (currentlyPlaying === this) currentlyPlaying = null;
            }
          }
        });

        video.addEventListener('play', function () {
          const card = this.closest('.video-card');
          if (!card) return;
          if (currentlyPlaying && currentlyPlaying !== this) {
            pauseAndReset(currentlyPlaying);
          }
          card.classList.add('playing');
          currentlyPlaying = this;
        });
      });

      const arrowBtns = document.querySelectorAll('.slider-arrow-btn[data-target="videoCarousel"]');
      arrowBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (currentlyPlaying) {
            setTimeout(function () {
              if (currentlyPlaying) {
                const card = currentlyPlaying.closest('.video-card');
                if (card) {
                  const rect = card.getBoundingClientRect();
                  const containerRect = carousel.getBoundingClientRect();
                  const isVisible = rect.right > containerRect.left + 20 && rect.left < containerRect.right - 20;
                  if (!isVisible) {
                    pauseAndReset(currentlyPlaying);
                    currentlyPlaying = null;
                  }
                }
              }
            }, 200);
          }
        });
      });

      let resizeTimer = null;
      window.addEventListener(
        'resize',
        function () {
          if (resizeTimer) clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            if (currentlyPlaying) {
              const card = currentlyPlaying.closest('.video-card');
              if (card) {
                const rect = card.getBoundingClientRect();
                const containerRect = carousel.getBoundingClientRect();
                const isVisible = rect.right > containerRect.left + 20 && rect.left < containerRect.right - 20;
                if (!isVisible) {
                  pauseAndReset(currentlyPlaying);
                  currentlyPlaying = null;
                }
              }
            }
          }, 150);
        },
        { passive: true }
      );

      carousel.querySelectorAll('video').forEach(function (video) {
        pauseAndReset(video);
      });
    })();

    // ─── CUSTOM CURSOR ───
    (function () {
      var cursor = document.getElementById('customCursor');
      if (!cursor) return;
      var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (isTouch) {
        cursor.style.display = 'none';
        return;
      }

      var mouseX = 0,
        mouseY = 0;
      var cursorX = 0,
        cursorY = 0;

      document.addEventListener('mousemove', function (e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
      });

      function animateCursor() {
        cursorX += (mouseX - cursorX) * 0.15;
        cursorY += (mouseY - cursorY) * 0.15;
        cursor.style.left = cursorX + 'px';
        cursor.style.top = cursorY + 'px';
        requestAnimationFrame(animateCursor);
      }
      animateCursor();

      var hoverTargets = document.querySelectorAll(
        'a, button, .btn-primary, .btn-dark, .btn-brown, .btn-pink, .product-card, .feature-card, .badge, .feature-box, input, select, textarea'
      );
      hoverTargets.forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          cursor.classList.add('hovering');
        });
        el.addEventListener('mouseleave', function () {
          cursor.classList.remove('hovering');
        });
      });

      document.addEventListener('mouseleave', function () {
        cursor.style.opacity = '0';
      });
      document.addEventListener('mouseenter', function () {
        cursor.style.opacity = '1';
      });
    })();

    // ─── CURSOR TRAIL ───
    (function () {
      var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (isTouch) return;
      var trailDots = [];
      var maxDots = 12;
      var dotSize = 6;

      function createTrailDot(x, y) {
        var dot = document.createElement('div');
        dot.className = 'cursor-trail';
        var size = dotSize * (0.4 + Math.random() * 0.6);
        dot.style.width = size + 'px';
        dot.style.height = size + 'px';
        dot.style.left = x + 'px';
        dot.style.top = y + 'px';
        dot.style.background = 'rgba(235, 138, 172, ' + (0.2 + Math.random() * 0.3) + ')';
        dot.style.opacity = '1';
        document.body.appendChild(dot);
        return dot;
      }

      var positions = [];

      document.addEventListener('mousemove', function (e) {
        positions.push({ x: e.clientX, y: e.clientY });
        if (positions.length > maxDots) positions.shift();

        while (trailDots.length < positions.length) {
          var p = positions[trailDots.length];
          trailDots.push(createTrailDot(p.x, p.y));
        }

        for (var i = 0; i < trailDots.length; i++) {
          var idx = Math.max(0, i - 1);
          var pos = positions[idx] || positions[0];
          var progress = i / trailDots.length;
          var scale = 1 - progress * 0.7;
          var opacity = 1 - progress * 0.8;
          var size = dotSize * (0.3 + 0.7 * scale);
          trailDots[i].style.left = pos.x + 'px';
          trailDots[i].style.top = pos.y + 'px';
          trailDots[i].style.width = size + 'px';
          trailDots[i].style.height = size + 'px';
          trailDots[i].style.opacity = opacity;
          trailDots[i].style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
        }

        while (trailDots.length > maxDots) {
          var removed = trailDots.pop();
          if (removed && removed.parentNode) removed.parentNode.removeChild(removed);
        }
      });

      document.addEventListener('mouseleave', function () {
        trailDots.forEach(function (dot) {
          if (dot && dot.parentNode) dot.parentNode.removeChild(dot);
        });
        trailDots = [];
        positions = [];
      });
    })();

    // ─── BACK TO TOP ───
    (function () {
      var btn = document.getElementById('backToTop');
      if (!btn) return;
      var progressRing = btn.querySelector('.progress-ring');
      var circumference = 2 * Math.PI * 27;
      progressRing.style.strokeDasharray = circumference;
      progressRing.style.strokeDashoffset = circumference;

      function updateProgress() {
        var scrollTop = window.scrollY;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var progress = docHeight > 0 ? scrollTop / docHeight : 0;
        var offset = circumference - progress * circumference;
        progressRing.style.strokeDashoffset = offset;

        if (scrollTop > 300) {
          btn.classList.add('show');
        } else {
          btn.classList.remove('show');
        }
        progressRing.style.stroke = progress >= 0.99 ? '#fb3f52' : '#eb8aac';
      }
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    })();

    // ─── MOUSE GLOW ───
    var glow = document.getElementById('mouseGlow');
    if (glow) {
      var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (!isTouch) {
        var active = false,
          timeout;
        document.addEventListener('mousemove', function (e) {
          var x = e.clientX || e.pageX || 0,
            y = e.clientY || e.pageY || 0;
          glow.style.left = x + 'px';
          glow.style.top = y + 'px';
          if (!active) {
            active = true;
            glow.classList.add('active');
          }
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            active = false;
            glow.classList.remove('active');
          }, 800);
        });
        document.addEventListener('mouseleave', function () {
          active = false;
          glow.classList.remove('active');
        });
      } else {
        glow.style.display = 'none';
      }
    }

    // ─── PARTICLES ───
    (function () {
      var container = document.getElementById('particlesContainer');
      if (!container) return;
      var colors = ['#eb8aac', '#ffccde', '#ffafcb', '#fb3f52', '#ffd7e3'];
      for (var i = 0; i < 35; i++) {
        var p = document.createElement('div');
        p.className = 'particle';
        var size = 4 + Math.random() * 16;
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        p.style.left = Math.random() * 100 + '%';
        p.style.background = colors[Math.floor(Math.random() * colors.length)];
        p.style.animationDuration = 15 + Math.random() * 25 + 's';
        p.style.animationDelay = Math.random() * 30 + 's';
        p.style.opacity = 0.08 + Math.random() * 0.18;
        container.appendChild(p);
      }
    })();

    // ─── REVEAL ON SCROLL ───
    var revealTargets = document.querySelectorAll(
      '.reveal, .reveal-scale, .spend-less-header h2, .benefit-card, .cost-table-card, .feature-box'
    );
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('reveal-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      revealTargets.forEach(function (el) {
        el.classList.add('reveal-visible');
      });
    }

    document.querySelectorAll('.benefits-grid .benefit-card').forEach(function (el, i) {
      el.style.transitionDelay = i * 0.1 + 's';
    });

    // ─── BAR FILLS ───
    var bars = document.querySelectorAll('.table-row .bar-fill');
    if ('IntersectionObserver' in window) {
      var barObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var bar = entry.target;
              var target = bar.getAttribute('data-width') || '0';
              setTimeout(function () {
                bar.style.width = target + '%';
              }, 180);
              barObserver.unobserve(bar);
            }
          });
        },
        { threshold: 0.35 }
      );
      bars.forEach(function (bar) {
        barObserver.observe(bar);
      });
    } else {
      bars.forEach(function (bar) {
        bar.style.width = (bar.getAttribute('data-width') || '0') + '%';
      });
    }

    // ─── COUNT UP ───
    function animateCount(el) {
      var to = parseFloat(el.getAttribute('data-count-to') || '0');
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1500,
        start = null;

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = to * eased;
        el.textContent = (decimals ? value.toFixed(decimals) : Math.floor(value).toLocaleString('en-US')) + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = (decimals ? to.toFixed(decimals) : Math.floor(to).toLocaleString('en-US')) + suffix;
      }
      requestAnimationFrame(step);
    }

    var counters = document.querySelectorAll('.count-up');
    if ('IntersectionObserver' in window) {
      var countObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCount(entry.target);
              countObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );
      counters.forEach(function (el) {
        countObserver.observe(el);
      });
    } else {
      counters.forEach(function (el) {
        var to = parseFloat(el.getAttribute('data-count-to') || '0');
        var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var suffix = el.getAttribute('data-suffix') || '';
        el.textContent = (decimals ? to.toFixed(decimals) : Math.floor(to).toLocaleString('en-US')) + suffix;
      });
    }

    // ─── PARALLAX ───
    var parallaxSection = document.querySelector('.social-proof-section');
    var parallaxBg = document.querySelector('[data-parallax]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (parallaxSection && parallaxBg && !reduceMotion) {
      var ticking = false,
        speed = 0.22;

      function updateParallax() {
        var rect = parallaxSection.getBoundingClientRect();
        var viewportH = window.innerHeight;
        if (rect.bottom > -200 && rect.top < viewportH + 200) {
          var offset = (rect.top - viewportH / 2) * speed;
          parallaxBg.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
        }
        ticking = false;
      }

      function onScrollOrResize() {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      window.addEventListener('orientationchange', onScrollOrResize);
      updateParallax();
    }

    // ─── SLIDER ARROWS ───
    (function () {
      var buttons = document.querySelectorAll('.slider-arrow-btn');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = this.getAttribute('data-target');
          var container = document.getElementById(targetId);
          if (!container) return;
          var scrollAmount = container.clientWidth || 300;
          if (targetId === 'videoCarousel') {
            var firstCard = container.querySelector('.video-card');
            var gap = 24;
            scrollAmount = firstCard ? firstCard.getBoundingClientRect().width + gap : 357;
          }
          var direction = this.classList.contains('prev') ? -1 : 1;
          container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
        });
      });
    })();

    // ─── PRODUCT AUTO-SLIDE (mobile only) ───
    (function () {
      var grid = document.getElementById('productGrid');
      if (!grid) return;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      var autoTimer = null;
      var isMobile = window.innerWidth <= 768;
      var isPaused = false;

      function advance() {
        if (isPaused || !isMobile) return;
        var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
        if (atEnd) {
          grid.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' });
        }
      }

      function startAuto() {
        stopAuto();
        if (!isMobile) return;
        autoTimer = setInterval(advance, 3000);
      }

      function stopAuto() {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      }

      function handleInteraction() {
        if (!isMobile) return;
        isPaused = true;
        stopAuto();
        setTimeout(function () {
          isPaused = false;
          startAuto();
        }, 4000);
      }

      function handleResize() {
        var newMobile = window.innerWidth <= 768;
        if (newMobile !== isMobile) {
          isMobile = newMobile;
          if (isMobile) {
            startAuto();
          } else {
            stopAuto();
            isPaused = false;
          }
        }
      }

      window.addEventListener('resize', handleResize);

      // Interactions: touch, pointer, dots, arrows
      ['pointerdown', 'touchstart'].forEach(function (evt) {
        grid.addEventListener(evt, handleInteraction, { passive: true });
      });

      document.querySelectorAll('.product-dot, .slider-arrow-btn[data-target="productGrid"]').forEach(function (el) {
        el.addEventListener('click', handleInteraction);
      });

      // Start if mobile
      if (isMobile) {
        startAuto();
      }
    })();

    // ─── PRODUCT DOTS (existing) ───
    (function () {
      var grid = document.getElementById('productGrid');
      var dotsWrap = document.getElementById('productDots');
      if (!grid || !dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.product-dot'));
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
      if (!dots.length || !cards.length) return;

      function setActive(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === index);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-index'), 10) || 0;
          var target = cards[index];
          if (target) {
            grid.scrollTo({ left: target.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
          }
          setActive(index);
        });
      });

      var scrollTicking = false;
      grid.addEventListener(
        'scroll',
        function () {
          if (scrollTicking) return;
          scrollTicking = true;
          requestAnimationFrame(function () {
            var cardWidth = grid.clientWidth || 1;
            var index = Math.round(grid.scrollLeft / cardWidth);
            index = Math.max(0, Math.min(index, dots.length - 1));
            setActive(index);
            scrollTicking = false;
          });
        },
        { passive: true }
      );
    })();

    // ─── FAQ ACCORDION ───
    var faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(function (item) {
      var question = item.querySelector('.faq-question');
      if (!question) return;
      question.addEventListener('click', function () {
        var isActive = item.classList.contains('active');
        faqItems.forEach(function (f) {
          f.classList.remove('active');
        });
        if (!isActive) item.classList.add('active');
      });
    });

    // ─── THUMBNAIL SWITCH ───
    var thumbs = document.querySelectorAll('.thumb-wrapper');
    var mainImgWrappers = document.querySelectorAll('.ba-main-img .img-wrapper');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
        var imgs = thumb.querySelectorAll('img');
        if (imgs.length >= 2 && mainImgWrappers.length >= 2) {
          var beforeImg = mainImgWrappers[0].querySelector('img');
          var afterImg = mainImgWrappers[1].querySelector('img');
          if (beforeImg) beforeImg.src = imgs[0].src;
          if (afterImg) afterImg.src = imgs[1].src;
        }
      });
    });

    // ─── SMOOTH SCROLL ───
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;
        var targetEl = document.querySelector(targetId);
        if (targetEl) {
          e.preventDefault();
          var offset = 100;
          var top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    // ─── 3D TILT ON PRODUCT CARDS ───
    var productCards = document.querySelectorAll('.product-card');
    productCards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = this.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        var rotateX = -y * 6,
          rotateY = x * 6;
        this.style.transform =
          'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-12px) scale(1.02)';
      });
      card.addEventListener('mouseleave', function () {
        this.style.transform = '';
      });
    });

    // ─── HERO PARALLAX ON MOUSE ───
    var heroImgs = document.querySelectorAll('.hero-bg-images .bg-wrapper img');
    if (heroImgs.length) {
      var heroSection = document.querySelector('.hero-section');
      heroSection.addEventListener('mousemove', function (e) {
        var rect = this.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        heroImgs.forEach(function (img) {
          img.style.transform = 'translate(' + x * 6 + 'px, ' + y * 6 + 'px) scale(1.02)';
        });
      });
      heroSection.addEventListener('mouseleave', function () {
        heroImgs.forEach(function (img) {
          img.style.transform = 'translate(0,0) scale(1)';
        });
      });
    }

    // ─── BUTTON RIPPLE EFFECT ───
    document.querySelectorAll('.btn-primary, .btn-dark, .btn-brown, .btn-pink').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var rect = this.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var ripple = document.createElement('span');
        ripple.style.cssText =
          'position:absolute;border-radius:50%;background:rgba(255,255,255,0.4);width:60px;height:60px;left:' +
          (x - 30) +
          'px;top:' +
          (y - 30) +
          'px;transform:scale(0);transition:transform 0.5s ease,opacity 0.5s ease;pointer-events:none;';
        this.style.position = 'relative';
        this.style.overflow = 'hidden';
        this.appendChild(ripple);
        requestAnimationFrame(function () {
          ripple.style.transform = 'scale(4)';
          ripple.style.opacity = '0';
        });
        setTimeout(function () {
          ripple.remove();
        }, 600);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["30lb-landing-two"] && !Shopify.designMode) return;
  try {
    
      (function () {
        'use strict';

        // ─── COOL CUSTOM CURSOR ───
        (function () {
          var cursor = document.getElementById('customCursor');
          if (!cursor) return;
          var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (isTouch) {
            cursor.style.display = 'none';
            return;
          }

          var mouseX = 0,
            mouseY = 0;
          var cursorX = 0,
            cursorY = 0;

          document.addEventListener('mousemove', function (e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
          });

          function animateCursor() {
            cursorX += (mouseX - cursorX) * 0.15;
            cursorY += (mouseY - cursorY) * 0.15;
            cursor.style.left = cursorX + 'px';
            cursor.style.top = cursorY + 'px';
            requestAnimationFrame(animateCursor);
          }
          animateCursor();

          var hoverTargets = document.querySelectorAll(
            'a, button, .btn-primary, .btn-dark, .btn-brown, .btn-pink, .product-card, .feature-card, .badge, .feature-box, input, select, textarea'
          );
          hoverTargets.forEach(function (el) {
            el.addEventListener('mouseenter', function () {
              cursor.classList.add('hovering');
            });
            el.addEventListener('mouseleave', function () {
              cursor.classList.remove('hovering');
            });
          });

          document.addEventListener('mouseleave', function () {
            cursor.style.opacity = '0';
          });
          document.addEventListener('mouseenter', function () {
            cursor.style.opacity = '1';
          });
        })();

        // ─── CURSOR TRAIL ───
        (function () {
          var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (isTouch) return;
          var trailDots = [];
          var maxDots = 12;
          var dotSize = 6;

          function createTrailDot(x, y) {
            var dot = document.createElement('div');
            dot.className = 'cursor-trail';
            var size = dotSize * (0.4 + Math.random() * 0.6);
            dot.style.width = size + 'px';
            dot.style.height = size + 'px';
            dot.style.left = x + 'px';
            dot.style.top = y + 'px';
            dot.style.background = 'rgba(235, 138, 172, ' + (0.2 + Math.random() * 0.3) + ')';
            dot.style.opacity = '1';
            document.body.appendChild(dot);
            return dot;
          }

          var positions = [];

          document.addEventListener('mousemove', function (e) {
            positions.push({ x: e.clientX, y: e.clientY });
            if (positions.length > maxDots) positions.shift();

            while (trailDots.length < positions.length) {
              var p = positions[trailDots.length];
              trailDots.push(createTrailDot(p.x, p.y));
            }

            for (var i = 0; i < trailDots.length; i++) {
              var idx = Math.max(0, i - 1);
              var pos = positions[idx] || positions[0];
              var progress = i / trailDots.length;
              var scale = 1 - progress * 0.7;
              var opacity = 1 - progress * 0.8;
              var size = dotSize * (0.3 + 0.7 * scale);
              trailDots[i].style.left = pos.x + 'px';
              trailDots[i].style.top = pos.y + 'px';
              trailDots[i].style.width = size + 'px';
              trailDots[i].style.height = size + 'px';
              trailDots[i].style.opacity = opacity;
              trailDots[i].style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
            }

            while (trailDots.length > maxDots) {
              var removed = trailDots.pop();
              if (removed && removed.parentNode) removed.parentNode.removeChild(removed);
            }
          });

          document.addEventListener('mouseleave', function () {
            trailDots.forEach(function (dot) {
              if (dot && dot.parentNode) dot.parentNode.removeChild(dot);
            });
            trailDots = [];
            positions = [];
          });
        })();

        // ─── BACK TO TOP ───
        (function () {
          var btn = document.getElementById('backToTop');
          if (!btn) return;
          var progressRing = btn.querySelector('.progress-ring');
          var circumference = 2 * Math.PI * 27;
          progressRing.style.strokeDasharray = circumference;
          progressRing.style.strokeDashoffset = circumference;

          function updateProgress() {
            var scrollTop = window.scrollY;
            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
            var progress = docHeight > 0 ? scrollTop / docHeight : 0;
            var offset = circumference - progress * circumference;
            progressRing.style.strokeDashoffset = offset;

            if (scrollTop > 300) {
              btn.classList.add('show');
            } else {
              btn.classList.remove('show');
            }
            progressRing.style.stroke = progress >= 0.99 ? '#fb3f52' : '#eb8aac';
          }
          window.addEventListener('scroll', updateProgress, { passive: true });
          window.addEventListener('resize', updateProgress);
          updateProgress();
          btn.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
        })();

        // ─── MOUSE GLOW ───
        var glow = document.getElementById('mouseGlow');
        if (glow) {
          var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (!isTouch) {
            var active = false,
              timeout;
            document.addEventListener('mousemove', function (e) {
              var x = e.clientX || e.pageX || 0,
                y = e.clientY || e.pageY || 0;
              glow.style.left = x + 'px';
              glow.style.top = y + 'px';
              if (!active) {
                active = true;
                glow.classList.add('active');
              }
              clearTimeout(timeout);
              timeout = setTimeout(function () {
                active = false;
                glow.classList.remove('active');
              }, 800);
            });
            document.addEventListener('mouseleave', function () {
              active = false;
              glow.classList.remove('active');
            });
          } else {
            glow.style.display = 'none';
          }
        }

        // ─── PARTICLES ───
        (function () {
          var container = document.getElementById('particlesContainer');
          if (!container) return;
          var colors = ['#eb8aac', '#ffccde', '#ffafcb', '#fb3f52', '#ffd7e3'];
          for (var i = 0; i < 35; i++) {
            var p = document.createElement('div');
            p.className = 'particle';
            var size = 4 + Math.random() * 16;
            p.style.width = size + 'px';
            p.style.height = size + 'px';
            p.style.left = Math.random() * 100 + '%';
            p.style.background = colors[Math.floor(Math.random() * colors.length)];
            p.style.animationDuration = 15 + Math.random() * 25 + 's';
            p.style.animationDelay = Math.random() * 30 + 's';
            p.style.opacity = 0.08 + Math.random() * 0.18;
            container.appendChild(p);
          }
        })();

        // ─── REVEAL ON SCROLL ───
        var revealTargets = document.querySelectorAll(
          '.reveal, .reveal-scale, .spend-less-header h2, .benefit-card, .cost-table-card, .feature-box'
        );
        if ('IntersectionObserver' in window) {
          var revealObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('reveal-visible');
                  revealObserver.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
          );
          revealTargets.forEach(function (el) {
            revealObserver.observe(el);
          });
        } else {
          revealTargets.forEach(function (el) {
            el.classList.add('reveal-visible');
          });
        }

        document.querySelectorAll('.benefits-grid .benefit-card').forEach(function (el, i) {
          el.style.transitionDelay = i * 0.1 + 's';
        });

        // ─── BAR FILLS ───
        var bars = document.querySelectorAll('.table-row .bar-fill');
        if ('IntersectionObserver' in window) {
          var barObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  var bar = entry.target;
                  var target = bar.getAttribute('data-width') || '0';
                  setTimeout(function () {
                    bar.style.width = target + '%';
                  }, 180);
                  barObserver.unobserve(bar);
                }
              });
            },
            { threshold: 0.35 }
          );
          bars.forEach(function (bar) {
            barObserver.observe(bar);
          });
        } else {
          bars.forEach(function (bar) {
            bar.style.width = (bar.getAttribute('data-width') || '0') + '%';
          });
        }

        // ─── COUNT UP ───
        function animateCount(el) {
          var to = parseFloat(el.getAttribute('data-count-to') || '0');
          var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
          var suffix = el.getAttribute('data-suffix') || '';
          var duration = 1500,
            start = null;

          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = to * eased;
            el.textContent = (decimals ? value.toFixed(decimals) : Math.floor(value).toLocaleString('en-US')) + suffix;
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = (decimals ? to.toFixed(decimals) : Math.floor(to).toLocaleString('en-US')) + suffix;
          }
          requestAnimationFrame(step);
        }

        var counters = document.querySelectorAll('.count-up');
        if ('IntersectionObserver' in window) {
          var countObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  animateCount(entry.target);
                  countObserver.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.4 }
          );
          counters.forEach(function (el) {
            countObserver.observe(el);
          });
        } else {
          counters.forEach(function (el) {
            var to = parseFloat(el.getAttribute('data-count-to') || '0');
            var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
            var suffix = el.getAttribute('data-suffix') || '';
            el.textContent = (decimals ? to.toFixed(decimals) : Math.floor(to).toLocaleString('en-US')) + suffix;
          });
        }

        // ─── PARALLAX ───
        var parallaxSection = document.querySelector('.social-proof-section');
        var parallaxBg = document.querySelector('[data-parallax]');
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (parallaxSection && parallaxBg && !reduceMotion) {
          var ticking = false,
            speed = 0.22;

          function updateParallax() {
            var rect = parallaxSection.getBoundingClientRect();
            var viewportH = window.innerHeight;
            if (rect.bottom > -200 && rect.top < viewportH + 200) {
              var offset = (rect.top - viewportH / 2) * speed;
              parallaxBg.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
            }
            ticking = false;
          }

          function onScrollOrResize() {
            if (!ticking) {
              requestAnimationFrame(updateParallax);
              ticking = true;
            }
          }
          window.addEventListener('scroll', onScrollOrResize, { passive: true });
          window.addEventListener('resize', onScrollOrResize);
          window.addEventListener('orientationchange', onScrollOrResize);
          updateParallax();
        }

        // ─── SLIDER ARROWS ───
        (function () {
          var buttons = document.querySelectorAll('.slider-arrow-btn');
          buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
              var targetId = this.getAttribute('data-target');
              var container = document.getElementById(targetId);
              if (!container) return;
              var scrollAmount = container.clientWidth || 300;
              if (targetId === 'videoCarousel') {
                var firstCard = container.querySelector('.video-card');
                var gap = 24;
                scrollAmount = firstCard ? firstCard.getBoundingClientRect().width + gap : 357;
              }
              var direction = this.classList.contains('prev') ? -1 : 1;
              container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
            });
          });
        })();

        // ─── TRUST BADGES AUTO-SLIDE ───
        (function () {
          var container = document.getElementById('trustBadges');
          if (!container) return;
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduceMotion) return;
          var autoTimer = null;

          function isSliderActive() {
            return container.scrollWidth > container.clientWidth + 4;
          }

          function advance() {
            if (!isSliderActive()) return;
            var atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 4;
            if (atEnd) {
              container.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              container.scrollBy({ left: container.clientWidth, behavior: 'smooth' });
            }
          }

          function startAuto() {
            stopAuto();
            autoTimer = setInterval(advance, 3000);
          }

          function stopAuto() {
            if (autoTimer) {
              clearInterval(autoTimer);
              autoTimer = null;
            }
          }

          ['pointerdown', 'touchstart'].forEach(function (evt) {
            container.addEventListener(
              evt,
              function () {
                stopAuto();
                setTimeout(startAuto, 4000);
              },
              { passive: true }
            );
          });
          document.querySelectorAll('.badges-slider-wrapper .slider-arrow-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
              stopAuto();
              setTimeout(startAuto, 4000);
            });
          });
          window.addEventListener('resize', function () {
            stopAuto();
            startAuto();
          });
          startAuto();
        })();

        // ─── PRODUCT DOTS ───
        (function () {
          var grid = document.getElementById('productGrid');
          var dotsWrap = document.getElementById('productDots');
          if (!grid || !dotsWrap) return;
          var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.product-dot'));
          var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
          if (!dots.length || !cards.length) return;

          function setActive(index) {
            dots.forEach(function (dot, i) {
              dot.classList.toggle('active', i === index);
            });
          }

          dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
              var index = parseInt(this.getAttribute('data-index'), 10) || 0;
              var target = cards[index];
              if (target) {
                grid.scrollTo({ left: target.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
              }
              setActive(index);
            });
          });

          var scrollTicking = false;
          grid.addEventListener(
            'scroll',
            function () {
              if (scrollTicking) return;
              scrollTicking = true;
              requestAnimationFrame(function () {
                var cardWidth = grid.clientWidth || 1;
                var index = Math.round(grid.scrollLeft / cardWidth);
                index = Math.max(0, Math.min(index, dots.length - 1));
                setActive(index);
                scrollTicking = false;
              });
            },
            { passive: true }
          );
        })();

        // ─── FAQ ACCORDION ───
        var faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach(function (item) {
          var question = item.querySelector('.faq-question');
          if (!question) return;
          question.addEventListener('click', function () {
            var isActive = item.classList.contains('active');
            faqItems.forEach(function (f) {
              f.classList.remove('active');
            });
            if (!isActive) item.classList.add('active');
          });
        });

        // ─── THUMBNAIL SWITCH ───
        var thumbs = document.querySelectorAll('.thumb-wrapper');
        var mainImgWrappers = document.querySelectorAll('.ba-main-img .img-wrapper');
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            thumbs.forEach(function (t) {
              t.classList.remove('active');
            });
            thumb.classList.add('active');
            var imgs = thumb.querySelectorAll('img');
            if (imgs.length >= 2 && mainImgWrappers.length >= 2) {
              var beforeImg = mainImgWrappers[0].querySelector('img');
              var afterImg = mainImgWrappers[1].querySelector('img');
              if (beforeImg) beforeImg.src = imgs[0].src;
              if (afterImg) afterImg.src = imgs[1].src;
            }
          });
        });

        // ─── SMOOTH SCROLL ───
        document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
          anchor.addEventListener('click', function (e) {
            var targetId = this.getAttribute('href');
            if (targetId === '#') return;
            var targetEl = document.querySelector(targetId);
            if (targetEl) {
              e.preventDefault();
              var offset = 100;
              var top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          });
        });

        // ─── 3D TILT ON PRODUCT CARDS ───
        var productCards = document.querySelectorAll('.product-card');
        productCards.forEach(function (card) {
          card.addEventListener('mousemove', function (e) {
            var rect = this.getBoundingClientRect();
            var x = (e.clientX - rect.left) / rect.width - 0.5;
            var y = (e.clientY - rect.top) / rect.height - 0.5;
            var rotateX = -y * 6,
              rotateY = x * 6;
            this.style.transform =
              'perspective(800px) rotateX(' +
              rotateX +
              'deg) rotateY(' +
              rotateY +
              'deg) translateY(-12px) scale(1.02)';
          });
          card.addEventListener('mouseleave', function () {
            this.style.transform = '';
          });
        });

        // ─── HERO PARALLAX ON MOUSE ───
        var heroImgs = document.querySelectorAll('.hero-bg-images .bg-wrapper img');
        if (heroImgs.length) {
          var heroSection = document.querySelector('.hero-section');
          heroSection.addEventListener('mousemove', function (e) {
            var rect = this.getBoundingClientRect();
            var x = (e.clientX - rect.left) / rect.width - 0.5;
            var y = (e.clientY - rect.top) / rect.height - 0.5;
            heroImgs.forEach(function (img) {
              img.style.transform = 'translate(' + x * 6 + 'px, ' + y * 6 + 'px) scale(1.02)';
            });
          });
          heroSection.addEventListener('mouseleave', function () {
            heroImgs.forEach(function (img) {
              img.style.transform = 'translate(0,0) scale(1)';
            });
          });
        }

        // ─── BUTTON RIPPLE EFFECT ───
        document.querySelectorAll('.btn-primary, .btn-dark, .btn-brown, .btn-pink').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            var rect = this.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var y = e.clientY - rect.top;
            var ripple = document.createElement('span');
            ripple.style.cssText =
              'position:absolute;border-radius:50%;background:rgba(255,255,255,0.4);width:60px;height:60px;left:' +
              (x - 30) +
              'px;top:' +
              (y - 30) +
              'px;transform:scale(0);transition:transform 0.5s ease,opacity 0.5s ease;pointer-events:none;';
            this.style.position = 'relative';
            this.style.overflow = 'hidden';
            this.appendChild(ripple);
            requestAnimationFrame(function () {
              ripple.style.transform = 'scale(4)';
              ripple.style.opacity = '0';
            });
            setTimeout(function () {
              ripple.remove();
            }, 600);
          });
        });
      })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
